import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import type { AgentOptions } from "@newrelic/browser-agent/loaders/agent";

import "common/globalConfig";
import config from "react-global-configuration";

// Populate using values from NerdGraph
const options: AgentOptions = {
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ["bam.nr-data.net"] },
  },
  loader_config: {
    accountID: "3033310",
    trustKey: "3033310",
    agentID: config.get("NEWRELIC_APP_ID"),
    licenseKey: "NRJS-f6d0fe7c34d85cbdc58",
    applicationID: config.get("NEWRELIC_APP_ID"),
  },
  info: {
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    licenseKey: "NRJS-f6d0fe7c34d85cbdc58",
    applicationID: config.get("NEWRELIC_APP_ID"),
    sa: 1,
  },
};

// The agent loader code executes immediately on instantiation.
const nrba = new BrowserAgent(options);

(window as any).newrelic = nrba.api;
